// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT

export enum chartType {
  bar = 'bar',
  column = 'column',
}
